import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import { Button } from "@fluentui/react-components";
import { Modal } from "../modal/Modal";
import { AuthPopupRetryReason } from "../../utils/auth-popup-policy";

export function AuthPopupRetryDialog({ reason, onRetry, onCancel, onClose }) {
  return (
    <Modal
      title={<FormattedMessage id="auth-popup-retry-dialog.title" defaultMessage="This took longer than expected" />}
      onClose={onClose || onCancel}
      actions={
        <>
          <Button appearance="secondary" onClick={onCancel}>
            <FormattedMessage id="button.cancel" defaultMessage="Cancel" />
          </Button>
          <Button appearance="primary" onClick={onRetry}>
            <FormattedMessage id="button.try-again" defaultMessage="Try again" />
          </Button>
        </>
      }
    >
      <p style={{ margin: 0, textAlign: "left" }}>
        {reason === AuthPopupRetryReason.blocked ? (
          <FormattedMessage
            id="auth-popup-retry-dialog.blocked"
            defaultMessage="Your browser blocked the sign-in window. Allow pop-ups for this site and try again."
          />
        ) : (
          <FormattedMessage
            id="auth-popup-retry-dialog.timeout"
            defaultMessage="The sign-in window timed out before completion. Please try again."
          />
        )}
      </p>
    </Modal>
  );
}

AuthPopupRetryDialog.propTypes = {
  reason: PropTypes.oneOf([AuthPopupRetryReason.timeout, AuthPopupRetryReason.blocked]).isRequired,
  onRetry: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  onClose: PropTypes.func
};
